/* LUX v2 — Scroll reveal, lightbox, comparison dropdown */
(function () {
  if (typeof window === 'undefined') return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  if (!('IntersectionObserver' in window)) return;

  var REVEAL_SELECTORS = [
    '.lux2-eyebrow','.lux2-h-section','.lux2-story-image','.lux2-story-sub','.lux2-story-body',
    '.lux2-ritual__quote','.lux2-ritual__sub','.lux2-ritual__item','.lux2-construct-diagram',
    '.lux2-feat-row','.lux2-callout','.lux2-vs-side','.lux2-cov-item','.lux2-cov-dot',
    '.lux2-value-card','.lux2-lifestyle-img','.lux2-lifestyle-item','.lux2-spec-row',
    '.lux2-smart-card','.lux2-trust-badge','.lux2-style-card','.lux-snatch-card',
    '.lux-feature-card','.lux-fit-card','.lux-trust-item','.lux-review-card',
    '.lux-faq-item','.lux-timeline-step'
  ].join(',');

  function init() {
    var nodes = document.querySelectorAll(REVEAL_SELECTORS);
    if (!nodes.length) return;
    var perParentIndex = new WeakMap();
    nodes.forEach(function (el) {
      if (el.hasAttribute('data-lux-reveal')) return;
      el.setAttribute('data-lux-reveal', '');
      var parent = el.parentNode;
      var i = perParentIndex.get(parent) || 0;
      var stagger = Math.min(i, 6) * 60;
      el.style.transitionDelay = stagger + 'ms';
      perParentIndex.set(parent, i + 1);
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    nodes.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Lightbox */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  var lightbox = null, imgs = [], idx = 0, lastFocused = null;

  function buildLightbox() {
    var el = document.createElement('div');
    el.className = 'lux2-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image viewer');
    el.innerHTML = [
      '<button type="button" class="lux2-lightbox__close" aria-label="Close"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>',
      '<button type="button" class="lux2-lightbox__prev" aria-label="Previous image"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
      '<button type="button" class="lux2-lightbox__next" aria-label="Next image"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
      '<div class="lux2-lightbox__stage"><img class="lux2-lightbox__img" alt=""></div>',
      '<div class="lux2-lightbox__counter" aria-live="polite"></div>'
    ].join('');
    document.body.appendChild(el);
    el.querySelector('.lux2-lightbox__close').addEventListener('click', close);
    el.querySelector('.lux2-lightbox__prev').addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    el.querySelector('.lux2-lightbox__next').addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.classList.contains('lux2-lightbox__stage')) close();
    });
    return el;
  }

  function pickFullSrc(img) {
    if (img.dataset && img.dataset.luxFullsrc) return img.dataset.luxFullsrc;
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var best = '', bestW = 0;
      srcset.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var url = bits[0];
        var w = parseInt((bits[1] || '0').replace('w', ''), 10) || 0;
        if (w > bestW) { bestW = w; best = url; }
      });
      if (best) return best;
    }
    return img.currentSrc || img.src;
  }

  function update() {
    if (!lightbox) return;
    var current = imgs[idx];
    var stageImg = lightbox.querySelector('.lux2-lightbox__img');
    stageImg.src = pickFullSrc(current);
    stageImg.alt = current.alt || '';
    var counter = lightbox.querySelector('.lux2-lightbox__counter');
    if (counter) counter.textContent = (idx + 1) + ' / ' + imgs.length;
    var multi = imgs.length > 1;
    lightbox.querySelector('.lux2-lightbox__prev').style.display = multi ? '' : 'none';
    lightbox.querySelector('.lux2-lightbox__next').style.display = multi ? '' : 'none';
    if (counter) counter.style.display = multi ? '' : 'none';
  }

  function open(galleryImgs, startIdx) {
    imgs = galleryImgs;
    idx = startIdx || 0;
    if (!lightbox) lightbox = buildLightbox();
    update();
    lastFocused = document.activeElement;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    setTimeout(function () {
      var btn = lightbox.querySelector('.lux2-lightbox__close');
      if (btn) btn.focus();
    }, 30);
  }

  function close() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (e) {}
    }
  }

  function step(delta) {
    if (!imgs.length) return;
    idx = (idx + delta + imgs.length) % imgs.length;
    update();
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
  }

  function init() {
    var galleries = document.querySelectorAll('.lux2-gallery, .lux-gallery');
    if (!galleries.length) return;
    galleries.forEach(function (gallery) {
      var galleryImgs = Array.prototype.slice.call(gallery.querySelectorAll('img'));
      if (!galleryImgs.length) return;
      galleryImgs.forEach(function (img, i) {
        if (img.hasAttribute('data-lux-lightbox-bound')) return;
        img.setAttribute('data-lux-lightbox-bound', '');
        img.setAttribute('tabindex', '0');
        img.setAttribute('role', 'button');
        img.setAttribute('aria-label', 'Open image ' + (i + 1) + ' fullscreen');
        img.addEventListener('click', function (e) {
          e.preventDefault();
          open(galleryImgs, i);
        });
        img.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open(galleryImgs, i);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Comparison table mobile dropdown — dropdown lives inside the active competitor <th> */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function init() {
    var wraps = document.querySelectorAll('.lux-compare-wrap');
    if (!wraps.length) return;
    var COL_KEYS = ['feat', 'ours', 'b', 'c', 'd'];

    wraps.forEach(function (wrap) {
      if (wrap.hasAttribute('data-lux-compare-bound')) return;
      var table = wrap.querySelector('.lux-compare');
      if (!table) return;
      var headerCells = table.querySelectorAll('thead th');
      if (headerCells.length < 3) return;

      var rows = table.querySelectorAll('tr');
      rows.forEach(function (row) {
        var cells = row.children;
        for (var i = 0; i < cells.length; i++) {
          var key = COL_KEYS[i];
          if (key) cells[i].setAttribute('data-lux-col', key);
        }
      });

      var compCols = [];
      for (var i = 2; i < headerCells.length; i++) {
        var label = headerCells[i].textContent.trim();
        var key = COL_KEYS[i];
        if (label && key) compCols.push({ key: key, label: label });
      }
      if (compCols.length < 2) return;

      // Wrap original label text in a span so we can hide it ONLY on mobile.
      // Desktop keeps the static text visible.
      for (var k2 = 2; k2 < headerCells.length; k2++) {
        var th = headerCells[k2];
        var raw = th.textContent.trim();
        if (th.children.length === 0 && raw) {
          th.textContent = '';
          var label = document.createElement('span');
          label.className = 'lux-compare-comp-original';
          label.textContent = raw;
          th.appendChild(label);
        }
      }

      var selectorWrap = document.createElement('div');
      selectorWrap.className = 'lux-compare-mobile-selector';
      var prefix = document.createElement('span');
      prefix.className = 'lux-compare-mobile-selector__label';
      prefix.textContent = 'Compare with';
      var select = document.createElement('select');
      select.className = 'lux-compare-select';
      select.setAttribute('aria-label', 'Compare with');
      compCols.forEach(function (col) {
        var opt = document.createElement('option');
        opt.value = col.key;
        opt.textContent = col.label;
        select.appendChild(opt);
      });
      selectorWrap.appendChild(prefix);
      selectorWrap.appendChild(select);

      function moveSelectorToActive() {
        var key = select.value;
        var activeTh = table.querySelector('thead th[data-lux-col="' + key + '"]');
        if (activeTh && selectorWrap.parentNode !== activeTh) {
          activeTh.appendChild(selectorWrap);
        }
      }

      function updateActive() {
        wrap.setAttribute('data-lux-compare-active', select.value);
        moveSelectorToActive();
      }
      select.addEventListener('change', updateActive);
      updateActive();
      wrap.setAttribute('data-lux-compare-bound', '');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
